// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"ResetButton_resetButton__1TbDi"};